// A cancelled order, or one whose delivery failed, is not work in play: it
// keeps its own total on its own record and on any invoice already raised, but
// it is not what a day holds or what a week is expected to earn.
export const NON_COUNTING_STATUSES = ['cancelled', 'failed_delivery'];

export const isNonCountingStatus = (status) => NON_COUNTING_STATUSES.includes(status);

export const countsTowardWeek = (order) => !isNonCountingStatus(order?.status);
